import React from "react";
import { Card, Container } from "react-bootstrap";
import SalesPerDayClosureTable from "components/Tables/SalesPerDayClosureTable";

import { useTranslation } from "react-i18next";

function SalesStatsPage() {
  const {
    t,
  } = useTranslation();

  return (
    <>
      <Container fluid style={{ padding: "30px 0px" }}>
        <Card className="strpied-tabled-with-hover">
          <Card.Header>
            <Card.Title as="h4">{t("common.labels.cashClosures")}</Card.Title>
            <p className="card-category">{t("common.labels.excludesWastageAndSpecialItems")}</p>
          </Card.Header>
          <Card.Body className="table-responsive p-0">
            <SalesPerDayClosureTable />
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default SalesStatsPage;
